import { Component, Vue } from 'vue-property-decorator';
import { Modal, ModalProps } from "../common/Modal";
import i18n from "../service/locale/i18";

@Component
class PaymentAccess extends Vue {
    async showPayMessage() {
        const payParams = this.$store.getters['events/selectedEventViewParam']('accessPayments', null);

        if (payParams === null) {
            return false;
        }

        const modalParams: ModalProps = {
            title: payParams?.message?.title || i18n.t('meetings.networkingPayWindowTitle').toString(),
            contentText: payParams?.message?.body || i18n.t('meetings.networkingPayWindowBody').toString(),
            buttons: []
        };

        payParams?.pages?.pay && modalParams && modalParams.buttons && modalParams.buttons.push({
            text: payParams?.pages?.pay?.title || i18n.t('meetings.networkingPayButton').toString() || '',
            class: "is-red",
            returnValue: true
        });
        payParams?.pages?.info && modalParams && modalParams.buttons && modalParams.buttons.push({
            text: payParams?.pages?.info?.title || i18n.t('meetings.networkingInfoButton').toString(),
            class: "is-green is-outlined",
            returnValue: false
        });

        const modal = new Modal(modalParams),
            modalResult = (await modal.showConfirm());

        if (typeof modalResult === "boolean") {
            if (modalResult === true) {
                // Была нажата кнопка "Оплатить"
                this.processPayAction(payParams?.pages?.pay);
            } else {
                // Была нажата кнопка "Ознакомиться с информацией"
                this.processPayAction(payParams?.pages?.info);
            }
        }
    }

    processPayAction(params: any) {
        if (params?.type === "url" && params?.url) {
            window.open(params?.url, '_blank');
        }

        if (params?.type === "tab" && params?.objectId) {
            this.$router.push({
                name: 'Info', params: {
                    backend: this.$route.params?.backend,
                    objectId: params?.objectId
                }
            });
        }
    }
}

export { PaymentAccess }